class HeaderCategories extends Component {
    constructor(el) {
        super(el);
        this.categoryTitles = this.$findAll('[data-has-subcategories]');
        this.categories = this.$findAll('[data-main-subcategory]');
        this._init();
    }
    addCategoryListener(el) {
        const categoryToggle = el.querySelector('[data-subcategories-toggle]');
        const subCategories = el.querySelector('[data-subcategories]');

        categoryToggle.addEventListener('click', () => {
            categoryToggle.classList.toggle('is-active');
            subCategories.classList.toggle('is-active');
        });
    }

    closeAll(el) {
        el.querySelectorAll('.is-active').forEach(elem => elem.classList.remove('is-active'));
    }

    correctCategoryPositions() {
        this.categories.forEach(cat => {
            const clientRect = cat.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            const offset = 20;

            if (clientRect.x + clientRect.width > windowWidth - offset) {
                cat.style.left = 'auto';
                cat.style.right = '0';
            } else {
                cat.style.left = '0';
                cat.style.right = 'auto';
            }
        });
    }

    addEventListeners() {
        window.addEventListener('resize', () => this.correctCategoryPositions());
        window.addEventListener('orientationchange', () => this.correctCategoryPositions());
        this.categoryTitles.forEach(el => this.addCategoryListener(el));
        this.categories.forEach(el => el.addEventListener('mouseleave', () => this.closeAll(el)));
    }

    _init() {
        this.correctCategoryPositions();
        this.addEventListeners();
    }
}